module.exports = [
  {
    title: 'ID',
    key: 'id'
  },
  {
    title: 'Клиент',
    key: 'remote_addr'
  },
  {
    title: 'Логин',
    key: 'username'
  },
  {
    title: 'Метод',
    key: 'method'
  },
  {
    title: 'Адрес',
    key: 'path'
  },
  {
    title: 'Время запроса',
    key: 'response_time'
  },
  {
    title: 'Статус',
    key: 'status_code'
  },
  {
    title: 'Совершен',
    key: 'requested_at'
  }
]
